import { $host } from "../../http/index";

export async function trackEvent(event, data = {}) {
    try {
        await $host.post('/api/analytics/track', {
            event,
            ...data
        });
    } catch (e) {
        console.error('[analytics] trackEvent error:', e);
    }
}